<template>
  <card card-body-classes="table-full-width">
    <h4 slot="header" class="card-title">{{ $t('pt_locks.tableTitle') }}</h4>
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
          class="select-primary mb-3 pagination-select"
          v-model="pagination.perPage"
          placeholder="Per page"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <div class="row">
          <div class="col-6">
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </base-input>
          </div>
          <div class="col-6" v-if="teamId && $auth.can({pt_lock: 'create'}, 'permissions')">
            <create-lock-btn :creation-disabled="isPtLockDisabled" :team-id="teamId" :operators="operators" :disabled="operators.length <= 0"/>
          </div>
        </div>
      </div>

      <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="$t(column.label)"
        >
        </el-table-column>
        <el-table-column :label="$t('pt_locks.details.route')">
          <div slot-scope="{ row }">
            {{ row.route }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('pt_locks.details.schedule')">
          <div slot-scope="{ row }">
            {{ row.schedule }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('pt_locks.details.team')">
          <div slot-scope="{ row }">
            {{ $store.getters.getTeamByID(row.inspector_team_id).name }}
          </div>
        </el-table-column>
        <!-- Updated & Created -->
        <el-table-column :label="$t('generic.updated')">
          <div slot-scope="{ row }">
            {{ row.updated_at | time }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('generic.created')">
          <div slot-scope="{ row }">
            {{ row.created_at | time }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('generic.createdBy')">
          <div slot-scope="{ row }">
            {{ row.created_by }}
          </div>
        </el-table-column>
        <el-table-column
          v-if="$auth.can({pt_lock: 'delete'}, 'permissions')"
          align="right">
          <div slot-scope="props">
            <base-button
              @click.native="handleDelete(props.$index, props.row)"
              class="remove btn-link"
              type="danger"
              size="sm"
              icon
              :disabled="disableDeleteButton(props.row)"
            >
              <i class="tim-icons icon-simple-remove"></i>
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>
<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import CreateLockBtn from './CreatePtLockBtn';
import Fuse from 'fuse.js';
import swal from 'sweetalert2';
import {mapActions, mapState} from "vuex";

export default {
  name: 'operators',
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    CreateLockBtn
  },
  props: {
    teamId: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapState({
      loading: state => state.pt_locks.loading,
      error: state => state.pt_locks.error,
      operators: state => state.operator.data,
      operatorsLoading: state => state.operator.loading,
    }),
    isPtLockDisabled: function () {
      if (!this.$auth.user().inspector_team_id) {
        return true
      }

      if (!this.teamId) {
        return false
      }

      return this.$auth.user().inspector_team_id != this.teamId
    },

    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['mapping_id', 'garage_number'],
      tableColumns: [

        {
          prop: 'mapping_id',
          label: 'pt_locks.details.mapping_id',
        },
        {
          prop: 'garage_number',
          label: 'pt_locks.details.garage_number',
        },
        {
          prop: 'operator_id',
          label: 'pt_locks.details.operator_id',
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    ...mapActions(['LoadInspectorTeams', 'LoadPtLocks', 'LoadInspectorTeamPtLocks', 'DeletePtLock', 'LoadOperators']),
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.mapping_id === row.mapping_id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    disableDeleteButton(row) {
      if (this.$auth.check('admin')) {
        return false
      }

      return this.$auth.user().inspector_team_id != row.inspector_team_id
    },
    handleDelete(index, row) {
      swal({
        title: this.$t('pt_locks.delete.confirm'),
        text: row.mapping_id,
        confirmButtonText: this.$t('pt_locks.delete.actionButton'),
        cancelButtonText: this.$t('pt_locks.delete.cancelButton'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.DeletePtLock(row).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('pt_locks.delete.deletedNotification', row),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.deleteRow(row);
            }
          })
        }
      });
    },
  },
  mounted() {
    this.LoadOperators();
    this.LoadInspectorTeams();

    if (this.teamId) {
      this.LoadInspectorTeamPtLocks(this.teamId);
    } else {
      this.LoadPtLocks();
    }
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "$store.state.pt_locks.locks"(locks) {
      this.tableData = locks
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ['id', 'name'],
        threshold: 0.3
      });
    }
  }
};
</script>
<style scoped>
</style>
